import React from "react";
import { Box, type BoxProps } from "@chakra-ui/react";
import { IconFeature, type IconFeatureProps } from "components/icon-feature";
import { defaultAngleToTop, GradientCard } from "ui/cards";

type GradientProps = {
  variant: "gradient";
  gradientColor: "green" | "blue";
  feature: IconFeatureProps;
};

type OutlineProps = {
  variant: "outline";
  feature: IconFeatureProps;
};

type IconFeatureCardProps = GradientProps | OutlineProps;

/**
 * A small card intended to be used in a grid. Available in gradient or outline variants.
 * Used to display an SVG icon above copy about a feature.
 */
export function IconFeatureCard({ feature, ...props }: IconFeatureCardProps & BoxProps) {
  const iconFeatureProps: IconFeatureProps = {
    iconSize: "lg",
    titleFontSize: { base: "lg", sm: "xl", md: "24px" },
    descriptionFontSize: "md",
    skipDescriptionBalancing: true,
    ...feature,
  };
  const baseStyles: BoxProps = {
    border: "1px",
    borderRadius: "xl",
    pt: { base: 6, lg: 10, xl: 12 },
    px: { base: 6, xl: 10 },
    pb: { base: 8, lg: 12, xl: 14 },
    w: "100%",
  };

  if (props.variant === "outline") {
    return (
      <Box {...baseStyles} {...props} borderColor="white" color="white">
        <IconFeature {...iconFeatureProps} />
      </Box>
    );
  }

  return (
    <GradientCard {...baseStyles} {...props} variant={props.gradientColor} angle={defaultAngleToTop}>
      <IconFeature {...iconFeatureProps} />
    </GradientCard>
  );
}
